var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{style:(_vm.style),attrs:{"src":_vm.lazySrc,"srcset":_vm.lazySrcset},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }